import { useSelector } from 'react-redux'
import { selectFileInvalidStructure } from '../../StockAddressingInBatchSelectors'
import * as S from './InvalidStructureTable.styles'

export default () => {
  const invalidStructure = useSelector(selectFileInvalidStructure)

  if (!invalidStructure?.missingColumns || invalidStructure.missingColumns.length === 0) {
    return null
  }

  return (
    <S.Wrapper>
      <S.Title>Colunas Faltando na Tabela</S.Title>
      <S.List>
        {invalidStructure?.missingColumns?.map((columnName) => (
          <S.Item key={columnName} >{columnName}</S.Item>
        ))}
      </S.List>
    </S.Wrapper>
  )
}
